import {omit} from 'lodash'
import React, {forwardRef} from 'react'
import {Link} from 'react-router-dom'

const LinkBehavior = forwardRef(
  (props, ref) => (
    <Link
      ref={ref}
      to={props.to}
      {...omit(props, ['to'])}
    />
  )
)

export {LinkBehavior as default}
